import { createTestIds } from '../../utils';
import { elements } from '../FormField/FormField.test-ids';
import { selectionCardElements } from '../SelectionCard/SelectionCard.test-ids';

export const getCheckboxTestIds = createTestIds('checkbox', ['control', ...elements] as const);

export const getCheckboxCardTestIds = createTestIds('checkbox-card', [
  'control',
  ...selectionCardElements
] as const);
